class VariantSlider extends HTMLElement {
  constructor() {
    super();

    /**
     * Capture-phase listener so the selected-state check runs before the PDP's
     * click handler on the anchor marks the clicked swatch as selected.
     */
    this.addEventListener(
      'click',
      async (event) => {
        const swatch = event.target.closest('.swatch a');
        if (!swatch || swatch.closest('.swatch.selected')) {
          return;
        }

        await window.yieldToMain();
        this.dispatchEvent(new CustomEvent('swatch:change', { detail: { swatch } }));
      },
      true,
    );
  }
}

customElements.define('variant-slider', VariantSlider);
